import { UserRound } from "lucide-react";

import { getProfileAvatarOption } from "./avatar-options";
import "./profiles.css";

export interface ProfileAvatarProps {
  readonly avatarId: string;
  readonly size?: "medium" | "large";
}

export function ProfileAvatar({
  avatarId,
  size = "medium"
}: ProfileAvatarProps) {
  const avatar = getProfileAvatarOption(avatarId);
  const AvatarIcon = avatar?.icon ?? UserRound;

  return (
    <span
      aria-hidden="true"
      className={"profile-avatar profile-avatar--" + size}
      data-avatar-tone={avatar?.tone ?? "teal"}
    >
      <AvatarIcon />
    </span>
  );
}
